// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  font-size: 100%;
}

:root {
  --gray: rgba(150, 150, 150, 1);
  --gray-9: rgba(192, 189, 196, 0.9);
  --gray-8: rgba(192, 189, 196, 0.8);
  --gray-7: rgba(192, 189, 196, 0.7);
  --gray-6: rgba(192, 189, 196, 0.6);
  --gray-5: rgba(192, 189, 196, 0.5);
  --gray-4: rgba(192, 189, 196, 0.4);
  --gray-3: rgba(192, 189, 196, 0.3);
  --gray-2: rgba(192, 189, 196, 0.2);
  --gray-1: rgba(192, 189, 196, 0.1);

  --blue: rgba(45, 175, 230, 1);
  --blue-9: rgba(45, 175, 230, 0.9);
  --blue-8: rgba(45, 175, 230, 0.8);
  --blue-7: rgba(45, 175, 230, 0.7);
  --blue-6: rgba(45, 175, 230, 0.6);
  --blue-5: rgba(45, 175, 230, 0.5);
  --blue-4: rgba(45, 175, 230, 0.4);
  --blue-3: rgba(45, 175, 230, 0.3);
  --blue-2: rgba(45, 175, 230, 0.2);
  --blue-1: rgba(45, 175, 230, 0.1);

  --yellow: rgba(254, 202, 58, 1);
  --yellow-9: rgba(254, 202, 58, 0.9);
  --yellow-8: rgba(254, 202, 58, 0.8);
  --yellow-7: rgba(254, 202, 58, 0.7);
  --yellow-6: rgba(254, 202, 58, 0.6);
  --yellow-5: rgba(254, 202, 58, 0.5);
  --yellow-4: rgba(254, 202, 58, 0.4);
  --yellow-3: rgba(254, 202, 58, 0.3);
  --yellow-2: rgba(254, 202, 58, 0.2);
  --yellow-1: rgba(254, 202, 58, 0.1);

  --green: rgba(75, 177, 102, 1);
  --green-9: rgba(75, 177, 102, 0.9);
  --green-8: rgba(75, 177, 102, 0.8);
  --green-7: rgba(75, 177, 102, 0.7);
  --green-6: rgba(75, 177, 102, 0.6);
  --green-5: rgba(75, 177, 102, 0.5);
  --green-4: rgba(75, 177, 102, 0.4);
  --green-3: rgba(75, 177, 102, 0.3);
  --green-2: rgba(75, 177, 102, 0.2);
  --green-1: rgba(75, 177, 102, 0.1);
}


.text-blue {
  color: var(--blue) !important;
}

.text-yellow {
  color: var(--yellow) !important;
}

.text-green {
  color: var(--green) !important;
}

.text-gray {
  color: var(--gray) !important;
}

body.modal-open {
  max-height: var(--viewport-height) !important;
}

.modal {
  background-color: rgba(127, 127, 127, 0.7);
}

body.embeded .modal {
  max-height: var(--viewport-height) !important;
}

body.embeded .modal-content {
  max-height: calc(var(--viewport-height) * .8) !important;
}


.modal-full-height .modal-content {
  max-height: var(--viewport-height) !important;
}

body.embeded h1 {
  display: none;
}

body.embeded .app-layout {
  padding-top: 40px;
}

dt,
dd {
  margin-bottom: 0.5rem;
}

.modal-body {
  overflow-y: scroll;
}

@media screen and (max-width: 1600px) {
  .modal-xl {
    max-width: 96%;
  }
}

body.standalone #content {
  padding-top: 120px;
  transition: all 700ms;
  padding-bottom: 200px;
}

a,
a.default {
  color: #666;
  cursor: pointer;
}

a.default {
  text-decoration: none;
}

a.default:hover {
  text-decoration: underline;
}

.pointer {
  cursor: pointer !important;
}

*:focus {
  outline: 0;
  box-shadow: none !important;
  border-color: inherit !important;
}

button {
  border: none;
  border-radius: 5px;
}

.btn-sm {
  font-size: 0.8rem !important;
}

.text-green {
  color: #026E6E !important;
}

.text-gray-9,
.text-grey-9 {
  color: #999 !important;
}

body.standalone h1 {
  font-size: calc(1rem + 1vw);
  margin-bottom: 2rem;
}

body.standalone h2 {
  font-size: calc(0.8rem + 1vw);
  margin-bottom: 2rem;
}

body.standalone h3 {
  font-size: calc(0.7rem + 1vw);
  margin-bottom: 2rem;
}

.form-label {
  font-size: 0.8rem;
}

.form-group {
  margin-bottom: 15px;
}

small,
.small {
  font-size: 0.8em !important;
}

.big {
  font-size: 1.2rem !important;
}

.nowrap {
  white-space: nowrap;
}

table thead th {
  vertical-align: middle !important;
  background-color: #bbb;
  font-size: 0.8rem;
}

table thead.spacer,
table tr.spacer,
table thead.spacer th,
table thead.spacer td,
table tbody.spacer td,
table tr.spacer td {
  height: 0 !important;
  padding: 0 !important;
  background-color: transparent !important;
  border: 0px solid transparent !important;
  box-shadow: none !important;
}

.alert-dismissible .btn-close {
  padding: 8px 12px 0 0;
  font-size: 10px !important;
}

@media screen and (max-width: 1200px) {
  .container {
    width: 96% !important;
    max-width: 96% !important;
  }

  .container {}
}

.border-light {
  border-color: #dee2e6 !important;
}

img {
  max-width: 100%;
}

.accordion {
  border: none !important;
}

.accordion,
.accordion * {
  box-shadow: none !important;
}

.accordion-item {
  border: none !important
}

.accordion-header {
  border: none !important;
}

.accordion-header button {
  border: none !important;
  background-color: #fafafa !important;
  padding: 0 0 5px 0 !important;
  color: inherit !important;
}

.accordion-body {
  margin: 0;
  padding: 0
}

.modal .modal-dialog {}

.modal .modal-content {}

.modal-title {
  color: #333;
}

.modal-lg {
  max-width: 800px !important;
  width: 96% !important;
}

.text-decoration-hover {
  text-decoration: none;
}

.text-decoration-hover:hover {
  text-decoration: underline;
}

table.table-sm th,
table.table-sm td {
  padding: 0.5rem 0.5rem;
}

.construct {
  border: 1px dotted pink;
}

.w-20 {
  width: 20%;
}

.w-40 {
  width: 40%;
}

.w-45 {
  width: 45%;
}

.fs-7 {
  font-size: 0.9rem !important;
}

.fs-8 {
  font-size: 0.8rem !important;
}

.fs-9 {
  font-size: 0.7rem !important;
}


.fs-10 {
  font-size: 0.6rem !important;
}

table.table-sm th,
table.table-sm td {
  font-size: 0.8rem !important;
}

.montserrat-alternates-thin {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  font-style: normal;
}

.montserrat-alternates-extralight {
  font-family: "Roboto", sans-serif;
  font-weight: 200;
  font-style: normal;
}

.montserrat-alternates-light {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-style: normal;
}

.montserrat-alternates-regular {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.montserrat-alternates-medium {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-style: normal;
}

.montserrat-alternates-semibold {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.montserrat-alternates-bold {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
}

.montserrat-alternates-extrabold {
  font-family: "Roboto", sans-serif;
  font-weight: 800;
  font-style: normal;
}

.montserrat-alternates-black {
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  font-style: normal;
}

.montserrat-alternates-thin-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  font-style: italic;
}

.montserrat-alternates-extralight-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 200;
  font-style: italic;
}

.montserrat-alternates-light-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-style: italic;
}

.montserrat-alternates-regular-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-style: italic;
}

.montserrat-alternates-medium-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-style: italic;
}

.montserrat-alternates-semibold-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 600;
  font-style: italic;
}

.montserrat-alternates-bold-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-style: italic;
}

.montserrat-alternates-extrabold-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 800;
  font-style: italic;
}

.montserrat-alternates-black-italic {
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  font-style: italic;
}

body.embeded h1,
body.embeded h2,
body.embeded h3 {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
}

body.embeded h2 {
  font-size: 1.1rem;
  margin-bottom: 25px;
  color: var(--blue);
}

body.embeded h3 {
  font-size: 0.9rem;
  margin-bottom: 25px;
  color: #666;
}

input.form-control:focus {
  border: 1px solid var(--blue) !important;
  background-color: var(--blue-2);
}

.btn-blue {
  background-color: var(--blue-9);
  color: white
}

.btn-outline-blue {
  background-color: white;
  color: var(--blue);
  border: 1px solid var(--blue);
}

.btn-outline-blue:hover {
  background-color: var(--blue-9);
  color: white
}




.btn-blue:hover {
  background-color: var(--blue);
}

.btn-yellow {
  background-color: var(--yellow-9);
}

.btn-yellow:hover {
  background-color: var(--yellow);
}


.btn-green {
  background-color: var(--green-9);
}

.btn-green:hover {
  background-color: var(--green);
}`, "",{"version":3,"sources":["webpack://./src/css/app.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;;EAElC,6BAA6B;EAC7B,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;;EAEjC,+BAA+B;EAC/B,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;;EAEnC,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;AACpC;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,wDAAwD;AAC1D;;;AAGA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;;;;EAME,oBAAoB;EACpB,qBAAqB;EACrB,wCAAwC;EACxC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;;EAEA,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT;AACF;;AAEA,sBAAsB;;AAEtB,uBAAuB;;AAEvB;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B;AACF;;;;;AAKA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["html,\r\nbody {\r\n  font-size: 100%;\r\n}\r\n\r\n:root {\r\n  --gray: rgba(150, 150, 150, 1);\r\n  --gray-9: rgba(192, 189, 196, 0.9);\r\n  --gray-8: rgba(192, 189, 196, 0.8);\r\n  --gray-7: rgba(192, 189, 196, 0.7);\r\n  --gray-6: rgba(192, 189, 196, 0.6);\r\n  --gray-5: rgba(192, 189, 196, 0.5);\r\n  --gray-4: rgba(192, 189, 196, 0.4);\r\n  --gray-3: rgba(192, 189, 196, 0.3);\r\n  --gray-2: rgba(192, 189, 196, 0.2);\r\n  --gray-1: rgba(192, 189, 196, 0.1);\r\n\r\n  --blue: rgba(45, 175, 230, 1);\r\n  --blue-9: rgba(45, 175, 230, 0.9);\r\n  --blue-8: rgba(45, 175, 230, 0.8);\r\n  --blue-7: rgba(45, 175, 230, 0.7);\r\n  --blue-6: rgba(45, 175, 230, 0.6);\r\n  --blue-5: rgba(45, 175, 230, 0.5);\r\n  --blue-4: rgba(45, 175, 230, 0.4);\r\n  --blue-3: rgba(45, 175, 230, 0.3);\r\n  --blue-2: rgba(45, 175, 230, 0.2);\r\n  --blue-1: rgba(45, 175, 230, 0.1);\r\n\r\n  --yellow: rgba(254, 202, 58, 1);\r\n  --yellow-9: rgba(254, 202, 58, 0.9);\r\n  --yellow-8: rgba(254, 202, 58, 0.8);\r\n  --yellow-7: rgba(254, 202, 58, 0.7);\r\n  --yellow-6: rgba(254, 202, 58, 0.6);\r\n  --yellow-5: rgba(254, 202, 58, 0.5);\r\n  --yellow-4: rgba(254, 202, 58, 0.4);\r\n  --yellow-3: rgba(254, 202, 58, 0.3);\r\n  --yellow-2: rgba(254, 202, 58, 0.2);\r\n  --yellow-1: rgba(254, 202, 58, 0.1);\r\n\r\n  --green: rgba(75, 177, 102, 1);\r\n  --green-9: rgba(75, 177, 102, 0.9);\r\n  --green-8: rgba(75, 177, 102, 0.8);\r\n  --green-7: rgba(75, 177, 102, 0.7);\r\n  --green-6: rgba(75, 177, 102, 0.6);\r\n  --green-5: rgba(75, 177, 102, 0.5);\r\n  --green-4: rgba(75, 177, 102, 0.4);\r\n  --green-3: rgba(75, 177, 102, 0.3);\r\n  --green-2: rgba(75, 177, 102, 0.2);\r\n  --green-1: rgba(75, 177, 102, 0.1);\r\n}\r\n\r\n\r\n.text-blue {\r\n  color: var(--blue) !important;\r\n}\r\n\r\n.text-yellow {\r\n  color: var(--yellow) !important;\r\n}\r\n\r\n.text-green {\r\n  color: var(--green) !important;\r\n}\r\n\r\n.text-gray {\r\n  color: var(--gray) !important;\r\n}\r\n\r\nbody.modal-open {\r\n  max-height: var(--viewport-height) !important;\r\n}\r\n\r\n.modal {\r\n  background-color: rgba(127, 127, 127, 0.7);\r\n}\r\n\r\nbody.embeded .modal {\r\n  max-height: var(--viewport-height) !important;\r\n}\r\n\r\nbody.embeded .modal-content {\r\n  max-height: calc(var(--viewport-height) * .8) !important;\r\n}\r\n\r\n\r\n.modal-full-height .modal-content {\r\n  max-height: var(--viewport-height) !important;\r\n}\r\n\r\nbody.embeded h1 {\r\n  display: none;\r\n}\r\n\r\nbody.embeded .app-layout {\r\n  padding-top: 40px;\r\n}\r\n\r\ndt,\r\ndd {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.modal-body {\r\n  overflow-y: scroll;\r\n}\r\n\r\n@media screen and (max-width: 1600px) {\r\n  .modal-xl {\r\n    max-width: 96%;\r\n  }\r\n}\r\n\r\nbody.standalone #content {\r\n  padding-top: 120px;\r\n  transition: all 700ms;\r\n  padding-bottom: 200px;\r\n}\r\n\r\na,\r\na.default {\r\n  color: #666;\r\n  cursor: pointer;\r\n}\r\n\r\na.default {\r\n  text-decoration: none;\r\n}\r\n\r\na.default:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer !important;\r\n}\r\n\r\n*:focus {\r\n  outline: 0;\r\n  box-shadow: none !important;\r\n  border-color: inherit !important;\r\n}\r\n\r\nbutton {\r\n  border: none;\r\n  border-radius: 5px;\r\n}\r\n\r\n.btn-sm {\r\n  font-size: 0.8rem !important;\r\n}\r\n\r\n.text-green {\r\n  color: #026E6E !important;\r\n}\r\n\r\n.text-gray-9,\r\n.text-grey-9 {\r\n  color: #999 !important;\r\n}\r\n\r\nbody.standalone h1 {\r\n  font-size: calc(1rem + 1vw);\r\n  margin-bottom: 2rem;\r\n}\r\n\r\nbody.standalone h2 {\r\n  font-size: calc(0.8rem + 1vw);\r\n  margin-bottom: 2rem;\r\n}\r\n\r\nbody.standalone h3 {\r\n  font-size: calc(0.7rem + 1vw);\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.form-label {\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 15px;\r\n}\r\n\r\nsmall,\r\n.small {\r\n  font-size: 0.8em !important;\r\n}\r\n\r\n.big {\r\n  font-size: 1.2rem !important;\r\n}\r\n\r\n.nowrap {\r\n  white-space: nowrap;\r\n}\r\n\r\ntable thead th {\r\n  vertical-align: middle !important;\r\n  background-color: #bbb;\r\n  font-size: 0.8rem;\r\n}\r\n\r\ntable thead.spacer,\r\ntable tr.spacer,\r\ntable thead.spacer th,\r\ntable thead.spacer td,\r\ntable tbody.spacer td,\r\ntable tr.spacer td {\r\n  height: 0 !important;\r\n  padding: 0 !important;\r\n  background-color: transparent !important;\r\n  border: 0px solid transparent !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.alert-dismissible .btn-close {\r\n  padding: 8px 12px 0 0;\r\n  font-size: 10px !important;\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n  .container {\r\n    width: 96% !important;\r\n    max-width: 96% !important;\r\n  }\r\n\r\n  .container {}\r\n}\r\n\r\n.border-light {\r\n  border-color: #dee2e6 !important;\r\n}\r\n\r\nimg {\r\n  max-width: 100%;\r\n}\r\n\r\n.accordion {\r\n  border: none !important;\r\n}\r\n\r\n.accordion,\r\n.accordion * {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.accordion-item {\r\n  border: none !important\r\n}\r\n\r\n.accordion-header {\r\n  border: none !important;\r\n}\r\n\r\n.accordion-header button {\r\n  border: none !important;\r\n  background-color: #fafafa !important;\r\n  padding: 0 0 5px 0 !important;\r\n  color: inherit !important;\r\n}\r\n\r\n.accordion-body {\r\n  margin: 0;\r\n  padding: 0\r\n}\r\n\r\n.modal .modal-dialog {}\r\n\r\n.modal .modal-content {}\r\n\r\n.modal-title {\r\n  color: #333;\r\n}\r\n\r\n.modal-lg {\r\n  max-width: 800px !important;\r\n  width: 96% !important;\r\n}\r\n\r\n.text-decoration-hover {\r\n  text-decoration: none;\r\n}\r\n\r\n.text-decoration-hover:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\ntable.table-sm th,\r\ntable.table-sm td {\r\n  padding: 0.5rem 0.5rem;\r\n}\r\n\r\n.construct {\r\n  border: 1px dotted pink;\r\n}\r\n\r\n.w-20 {\r\n  width: 20%;\r\n}\r\n\r\n.w-40 {\r\n  width: 40%;\r\n}\r\n\r\n.w-45 {\r\n  width: 45%;\r\n}\r\n\r\n.fs-7 {\r\n  font-size: 0.9rem !important;\r\n}\r\n\r\n.fs-8 {\r\n  font-size: 0.8rem !important;\r\n}\r\n\r\n.fs-9 {\r\n  font-size: 0.7rem !important;\r\n}\r\n\r\n\r\n.fs-10 {\r\n  font-size: 0.6rem !important;\r\n}\r\n\r\ntable.table-sm th,\r\ntable.table-sm td {\r\n  font-size: 0.8rem !important;\r\n}\r\n\r\n.montserrat-alternates-thin {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 100;\r\n  font-style: normal;\r\n}\r\n\r\n.montserrat-alternates-extralight {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 200;\r\n  font-style: normal;\r\n}\r\n\r\n.montserrat-alternates-light {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 300;\r\n  font-style: normal;\r\n}\r\n\r\n.montserrat-alternates-regular {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n\r\n.montserrat-alternates-medium {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 500;\r\n  font-style: normal;\r\n}\r\n\r\n.montserrat-alternates-semibold {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 600;\r\n  font-style: normal;\r\n}\r\n\r\n.montserrat-alternates-bold {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 700;\r\n  font-style: normal;\r\n}\r\n\r\n.montserrat-alternates-extrabold {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 800;\r\n  font-style: normal;\r\n}\r\n\r\n.montserrat-alternates-black {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 900;\r\n  font-style: normal;\r\n}\r\n\r\n.montserrat-alternates-thin-italic {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 100;\r\n  font-style: italic;\r\n}\r\n\r\n.montserrat-alternates-extralight-italic {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 200;\r\n  font-style: italic;\r\n}\r\n\r\n.montserrat-alternates-light-italic {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 300;\r\n  font-style: italic;\r\n}\r\n\r\n.montserrat-alternates-regular-italic {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 400;\r\n  font-style: italic;\r\n}\r\n\r\n.montserrat-alternates-medium-italic {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 500;\r\n  font-style: italic;\r\n}\r\n\r\n.montserrat-alternates-semibold-italic {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 600;\r\n  font-style: italic;\r\n}\r\n\r\n.montserrat-alternates-bold-italic {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 700;\r\n  font-style: italic;\r\n}\r\n\r\n.montserrat-alternates-extrabold-italic {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 800;\r\n  font-style: italic;\r\n}\r\n\r\n.montserrat-alternates-black-italic {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 900;\r\n  font-style: italic;\r\n}\r\n\r\nbody.embeded h1,\r\nbody.embeded h2,\r\nbody.embeded h3 {\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: 700;\r\n  font-style: normal;\r\n}\r\n\r\nbody.embeded h2 {\r\n  font-size: 1.1rem;\r\n  margin-bottom: 25px;\r\n  color: var(--blue);\r\n}\r\n\r\nbody.embeded h3 {\r\n  font-size: 0.9rem;\r\n  margin-bottom: 25px;\r\n  color: #666;\r\n}\r\n\r\ninput.form-control:focus {\r\n  border: 1px solid var(--blue) !important;\r\n  background-color: var(--blue-2);\r\n}\r\n\r\n.btn-blue {\r\n  background-color: var(--blue-9);\r\n  color: white\r\n}\r\n\r\n.btn-outline-blue {\r\n  background-color: white;\r\n  color: var(--blue);\r\n  border: 1px solid var(--blue);\r\n}\r\n\r\n.btn-outline-blue:hover {\r\n  background-color: var(--blue-9);\r\n  color: white\r\n}\r\n\r\n\r\n\r\n\r\n.btn-blue:hover {\r\n  background-color: var(--blue);\r\n}\r\n\r\n.btn-yellow {\r\n  background-color: var(--yellow-9);\r\n}\r\n\r\n.btn-yellow:hover {\r\n  background-color: var(--yellow);\r\n}\r\n\r\n\r\n.btn-green {\r\n  background-color: var(--green-9);\r\n}\r\n\r\n.btn-green:hover {\r\n  background-color: var(--green);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
